// src/hooks/useWebSocket.js
import { useState, useEffect, useCallback } from 'react';
import { tigerWebSocketService } from '../services/tigerWebSocket';
// import { tigerRestApi } from '../services/tigerRestApi';
// import { usePolling } from './usePolling';

// export const useWebSocket = () => {
//   const [realTimePrices, setRealTimePrices] = useState({});
//   const [isConnected, setIsConnected] = useState(false);
//   const [useWebSockets, setUseWebSockets] = useState(false);
  
//   const { prices: polledPrices, startPolling, stopPolling } = usePolling([], 5000);

//   // Try WebSocket first, fallback to polling
//   const connect = useCallback(async (symbols) => {
//     try {
//       console.log('Attempting WebSocket connection...');
      
//       // Try WebSocket connection
//       setUseWebSockets(true);
//       setIsConnected(true);
      
//       // If WebSocket fails, it will automatically fall back to polling
//       // through the error handling
      
//     } catch (error) {
//       console.warn('WebSocket failed, falling back to polling');
//       setUseWebSockets(false);
//       startPolling(symbols);
//     }
//   }, [startPolling]);

//   useEffect(() => {
//     if (useWebSockets) {
//       setRealTimePrices(realTimePrices);
//     } else {
//       setRealTimePrices(polledPrices);
//     }
//   }, [useWebSockets, realTimePrices, polledPrices]);

//   return {
//     realTimePrices,
//     isConnected: useWebSockets ? isConnected : true, // Polling is always "connected"
//     connectionMethod: useWebSockets ? 'websocket' : 'polling',
//     connect,
//     disconnect: stopPolling
//   };
// };

export const useWebSocket = () => {
  const [realTimePrices, setRealTimePrices] = useState({});
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const [ws, setWs] = useState(null);

  const connectWebSocket = useCallback(async (symbols) => {

    try {
      setConnectionError(null);
      await tigerWebSocketService.connect();
      setIsConnected(true);

      // Subscribe to each symbol
      symbols.forEach(symbol => {
        tigerWebSocketService.onQuoteUpdate(symbol, (quote) => {
          setRealTimePrices(prev => ({
            ...prev,
            [symbol]: quote.last // Real-time price
          }));
        });
      });

    } catch (error) {
      setConnectionError(error.message);
      setIsConnected(false);
      console.error('WebSocket connection failed:', error);
    }
  }, []);

  const disconnectWebSocket = useCallback(() => {
    tigerWebSocketService.disconnect();
    setIsConnected(false);
  }, []);

  const subscribeToSymbol = useCallback((symbol) => {
    tigerWebSocketService.onQuoteUpdate(symbol, (quote) => {
      setRealTimePrices(prev => ({
        ...prev,
        [symbol]: quote.last
      }));
    });
  }, []);

  const unsubscribeFromSymbol = useCallback((symbol) => {
    tigerWebSocketService.offQuoteUpdate(symbol);
    setRealTimePrices(prev => {
      const newPrices = { ...prev };
      delete newPrices[symbol];
      return newPrices;
    });
  }, []);

  useEffect(() => {
    return () => {
      disconnectWebSocket();
    };
  }, [disconnectWebSocket]);

  return {
    realTimePrices,
    isConnected,
    connectionError,
    connectWebSocket,
    disconnectWebSocket,
    subscribeToSymbol,
    unsubscribeFromSymbol
  };
};